import React from 'react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { SignIn } from '@clerk/clerk-react';

// Clerk Sign-In page replacing custom login logic
const Login = () => {
  // Determine redirect after successful sign-in – use query param `redirect` or default to mentorship page
  const params = new URLSearchParams(window.location.search);
  const redirectUrl = params.get('redirect') ?? '/mentorship-content';

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow flex items-center justify-center bg-gray-50 py-12">
        <Card className="w-full max-w-md mx-4">
          <CardHeader className="text-center">
            <CardTitle className="text-2xl font-serif text-indigo-900">Sign In</CardTitle>
          </CardHeader>
          <CardContent>
            <SignIn redirectUrl={redirectUrl} routing="hash" path="/login" />
          </CardContent>
        </Card>
      </main>
      <Footer />
    </div>
  );
};

export default Login;